import ServiceCore, { HttpMethod } from '../core'
import AuthService from '../auth'
import EphemeralStoreService from '../ephemeral-store'
import StringTableService from '../string-table'
import Q from 'q'
import { React } from 'react'
import { Redirect } from 'react-router-dom'

const config = require('../../include/site.config.json')
const baseURL = config.osprey.api
const store = new EphemeralStoreService()

const workspaceKey = StringTableService.getString(StringTableService.keys.workspaceKey)

export default class OspreyApiHelper {

    /**
     * Appends common headers to requests, including the auth token and workspace ORN
     * @param {Object} options 
     * @returns {Promise<*>}
     */
    static async authenticatedRequest(options) {
        if (!options.headers) {
            options.headers = {}
        }

        try {
            const token = await AuthService.getToken()
            const workspace = await store.get(workspaceKey)
            var authHeader = `Bearer ${token}`
            const initialEntityId = await AuthService.getInitialEntityId()

            if ((options.url == '/me') && initialEntityId) {
                   authHeader += ` ${initialEntityId}`
            }

            options.headers = Object.assign({
                Authorization: authHeader,
                'X-Context-Orn': workspace ? JSON.parse(workspace).orn : undefined
            }, options.headers)

            const result = await ServiceCore.request(options)
            return result
        } catch (error) {
            console.log(JSON.stringify(error))
            if ([401, 403].includes(error.response.status)) {
                const isLoggedIn = await AuthService.checkLoginStatus()
                console.log(`Logged in: ${isLoggedIn}`)
                if (!isLoggedIn) {
                    // If not logged in, update our status to match
                    await AuthService.logout()
                    window.logout()
                }
            }
            throw error
        }
    }


    /**
     * Handle the result of an API call. If the result is 401 or 403 (unauthorized), log out the user.
     * This will often be the first indication we get that the auth token has expired, or the user
     * has logged out somewhere else. In that case, redirect to the logout page.
     * Otherwise, update the auth token and return the result.
     * @static
     * @param {Object} result 
     * @returns 
     */
    static async handleResult(result) {
        // Functionality moved - TODO: remove this if it remains unused
        /*
        if ([401, 403].includes(result.status)) {
            const isLoggedIn = await AuthService.checkLoginStatus()
            if (!isLoggedIn) {
                // If not, update our status to match
                await AuthService.logout()
                window.logout()
            }
        }
        */
        return result
    }


    static async genericGet(url, params) {
        const options = {
            baseURL,
            url,
            method: HttpMethod.GET,
            params
        }

        const result = await OspreyApiHelper.authenticatedRequest(options)
        return await OspreyApiHelper.handleResult(result)
    }

    static genericPut(url, data) {
        const options = {
            baseURL,
            url,
            method: HttpMethod.PUT,
            data
        }

        const result = OspreyApiHelper.authenticatedRequest(options)
        return OspreyApiHelper.handleResult(result)
    }

    static genericPost(url, data) {
        const options = {
            baseURL,
            url,
            method: HttpMethod.POST,
            data
        }

        const result = OspreyApiHelper.authenticatedRequest(options)
        return OspreyApiHelper.handleResult(result)
    }

    static genericDelete(url, data) {
        const options = {
            baseURL,
            url,
            method: HttpMethod.DELETE,
            data
        }

        const result = OspreyApiHelper.authenticatedRequest(options)
        return OspreyApiHelper.handleResult(result)
    }
}


// WEBPACK FOOTER //
// src/services/osprey-api/helper.js